import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { CITIES } from "../../data/business";
import { CLEANING_AREAS } from "../../data/cleaningContent";

export default function ServiceArea() {
  return (
    <section id="areas" className="section">
      <div className="container-ss">
        <div className="max-w-2xl">
          <span className="pill mb-3">Service Area</span>
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            Cleaning services across <span className="text-[#1E3A8A]">Northwest Indiana</span>
          </h2>
          <p className="text-slate-600 mt-3">
            If you're looking for cleaning services near Lake Station, Indiana — or anywhere in
            Northwest Indiana — S.S. Cleaning Solutions would be happy to provide a quote.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mt-10">
          {CITIES.map((c) => {
            const Tag = c.featured ? Link : "div";
            const props = c.featured ? { to: `/areas/${c.slug}` } : {};
            return (
              <Tag
                key={c.slug}
                {...props}
                className={`group ss-card p-4 flex items-center justify-between gap-2 ${c.featured ? "cursor-pointer" : ""}`}
                data-testid={`area-${c.slug}`}
              >
                <span className="flex items-center gap-2 text-slate-800 font-medium">
                  <MapPin size={16} className="text-[#1E3A8A]" />
                  {c.name.replace(", IN", "")}
                </span>
                {c.featured && (
                  <ArrowRight size={16} className="text-slate-400 group-hover:text-[#1E3A8A] group-hover:translate-x-0.5 transition-all" />
                )}
              </Tag>
            );
          })}
        </div>
        <p className="mt-8 text-sm text-slate-600 leading-relaxed max-w-4xl" data-testid="area-surrounding-note">
          Also serving {CLEANING_AREAS.surrounding.join(", ")} and surrounding Northwest Indiana communities.{" "}
          {CLEANING_AREAS.illinoisNote}
        </p>
      </div>
    </section>
  );
}
